import { render, staticRenderFns } from "./TeacherManage.vue?vue&type=template&id=7ca8d104&scoped=true"
import script from "./TeacherManage.vue?vue&type=script&lang=js"
export * from "./TeacherManage.vue?vue&type=script&lang=js"
import style0 from "./TeacherManage.vue?vue&type=style&index=0&id=7ca8d104&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca8d104",
  null
  
)

export default component.exports